/* eslint-disable no-param-reassign */
import produce from 'immer';
var cellSetsCreated = produce(function (draft) {
  draft.creatingCellSets = false;
});
export default cellSetsCreated;